/**
 * HARDLOCK v18.12.71-STABLE-HYDRATION-FIX
 * Archivo critico de Planeacion/Seguimiento.
 * No modificar sin snapshot, pruebas hardlock, localhost validation y revision de no regresion.
 */
import { SectionMetrics } from './planningTypes';
import { PLANNING_SECTION_CONTRACT } from './planningConstants';
import { getHandler } from './sectionHandlers';
import { normalizeSectionContent, resolveCanonicalSectionNumber } from './normalizeSection';
import { validateRuntimeContract, resolveSectionNumberSafe } from './planningGuards';

export const computeSectionMetrics = (section: any): SectionMetrics => {
    if (!section) return { goal: 0, progress: 0, isValid: false };

    const rawSn = resolveCanonicalSectionNumber(section);
    const sn = resolveSectionNumberSafe(rawSn);
    
    // v18.12.41: VALIDACIÓN DE CONTRATO REAL (Anti-cross-section)
    const validation = validateRuntimeContract(section, sn);
    
    if (!sn || !validation.isValid) {
        return { 
            goal: section.goal || 0, 
            progress: 0, 
            isValid: false,
            integrityError: validation.error || 'Invalid Section Number'
        };
    }

    const contract = (PLANNING_SECTION_CONTRACT as any)[sn];
    const normalized = normalizeSectionContent(sn, section.content);
    
    const handler = getHandler(contract.type);
    
    // v18.12.41.3: S3 SURGICAL HARDLOCK
    // Si es la sección 3 (Diagnóstico), forzamos el cálculo por bloques históricos (Max 6)
    if (sn === 3) {
        const dbGoal = section.goal || section.meta_anual || 0;
        const s3Metrics = handler(normalized, dbGoal, 3);
        (s3Metrics as any).percentage = dbGoal > 0 ? (s3Metrics.progress / dbGoal) * 100 : 0;
        s3Metrics.isValid = true;
        return s3Metrics;
    }

    // v18.12.48: Pasamos el objeto normalizado COMPLETO para permitir búsqueda omnívora de datos.
    const metrics = handler(normalized, section.goal || 0, sn);
    
    // v18.12.42: Eliminamos el override goal=progress para permitir que los handlers 
    // calculen metas reales (ej. S5 cuenta comisiones establecidas vs vinculadas).
    
    // Cálculo centralizado de porcentaje
    (metrics as any).percentage = metrics.goal > 0 ? (metrics.progress / metrics.goal) * 100 : 0;
    metrics.isValid = true;

    return metrics;
};

// EXPORTACIÓN DE VERSIÓN PARA SEGUIMIENTO
export const METRICS_ENGINE_VERSION = "v18.12.71-HYDRATION-PERSISTENCE-HARDLOCK";
